import { Instant } from '@moojo/duration'
import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const IngestDeliveryEventRequest = z.object({
  timestamp: Instant.zod(),
  eventKind: z.union([
    z.literal('adRequest'),
    z.literal('recommendation'),
    z.literal('impression'),
    z.literal('engagement'),
  ]),
  details: z.record(z.string().or(z.number())),
})
export type IngestDeliveryEventRequest = z.infer<typeof IngestDeliveryEventRequest>

export const IngestDeliveryEventResponse = z.record(z.never())
export type IngestDeliveryEventResponse = z.infer<typeof IngestDeliveryEventResponse>

export const ingestDeliveryEventDeclaration = endpointDeclaration(
  IngestDeliveryEventRequest,
  IngestDeliveryEventResponse,
)
